<template>
    <DelayHydration>
        <div class="skeleton-container">
            <SkeletonPartsText animation="wave" width="30%" />
            <div class="skeleton">
                <div v-for="index in maxNumberOfProducts" :key="index" class="skeleton-div" :class="`skeleton-div--${maxNumberOfProducts}`">
                    <SkeletonPartsImage aspect="1:1" />
                    <div class="mt-3">
                        <SkeletonPartsText />
                        <SkeletonPartsText />
                        <SkeletonPartsText />
                    </div>
                    <div class="mt-3">
                        <SkeletonPartsText />
                    </div>
                    <div class="mt-3">
                        <SkeletonPartsText />
                    </div>
                    <div class="mt-3 d-flex justify-content-center">
                        <SkeletonPartsButton />
                    </div>
                </div>
            </div>
        </div>
    </DelayHydration>
</template>

<script lang="ts">
export default {
    props: {
        showTitle: {
            type: Boolean,
            default: false,
        },
        maxNumberOfProducts: {
            type: Number,
            default: 6,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
//@import '../../node_modules/bootstrap-vue/src/components/skeleton/skeleton';
.skeleton-container {
    position: relative;
    max-width: $max-width-container-inside;
    margin: 2em auto;
}
.skeleton {
    display: flex;
    overflow-x: auto;
    width: 100%;
    height: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 10px;
    }
    &:hover::-webkit-scrollbar-thumb {
        border: 0;
        background-color: $color-grey-semi-dark;
        border-radius: 10px;
        cursor: pointer;
        @media (min-width: 890px) {
            display: none;
        }
    }
}
.skeleton-div {
    flex: 0 0 calc(100% / 2.25);
    width: calc(100% / 2.25);
    padding: 1.5em 1em 0.5em;
    @media (min-width: 460px) {
        flex: 0 0 calc(100% / 2.25);
        width: calc(100% / 2.25);
    }

    &--4,
    &--5,
    &--6 {
        @media (min-width: 660px) {
            flex: 0 0 calc(100% / 3.5);
            width: calc(100% / 3.5);
        }
    }

    &--5,
    &--6 {
        @media (min-width: 860px) {
            flex: 0 0 calc(100% / 4.5);
            width: calc(100% / 4.5);
        }
    }

    &--6 {
        @media (min-width: 1024px) {
            flex: 0 0 calc(100% / 5.5);
            width: calc(100% / 5.5);
        }
    }
}
</style>
